var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"home"},[_c('div',{staticClass:"app-wrapper"},[_c('sidebar',{ref:"sidebar"}),_c('v-main',[_c('div',{staticClass:"main-content"},[_vm._t("content")],2)]),_c('topbar',{ref:"topbar"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }